// A required field is marked before it is touched (DD-056): a red star after its label, and a line above the footer
// that says what the disabled save is waiting for. FormField takes a node as its label, so the star lives here.
import type { ReactNode } from "react";
import { andList } from "../utils/format";

/** A label with the red star after it. Pair it with `aria-required` on the input. */
export function Required({ children }: { children: ReactNode }) {
  return (
    <>
      {children} <span aria-hidden="true" className="text-red-600">*</span>
    </>
  );
}

/** "Pay needs the invoice number." Nothing while nothing is missing, so a save disabled for another reason says nothing. */
export function MissingLine({ button, missing }: { button: string | string[]; missing: string[] }) {
  if (missing.length === 0) return null;
  const buttons = typeof button === "string" ? [button] : button;
  return <p className="text-xs text-gray-500">{`${andList(buttons)} ${buttons.length === 1 ? "needs" : "need"} ${andList(missing)}.`}</p>;
}
